import { cn } from '@repo/utils'

import styles from './index.css'

import type { ElementType, FC, HTMLAttributes, Ref } from 'react'

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType
  disabled?: boolean
  elevation?: 0 | 1 | 2 | 3
  innerRef?: Ref<unknown>
  to?: string
}

const Card: FC<CardProps> = ({ as, className, disabled, elevation = 0, innerRef, tabIndex = 0, ...props }) => {
  const Component = as || 'div'
  return (
    <Component
      {...props}
      className={cn('Card', styles.wrapper, styles[`elevation${elevation}`], disabled && styles.disabled, className)}
      ref={innerRef}
      tabIndex={disabled ? -1 : tabIndex}
    />
  )
}

export default Card
